import { ReactNode, SyntheticEvent } from 'react';
import { CheckboxVariant, VisualAsset } from 'core/flow/entities';
import { Checkbox } from '../../Checkbox';
import { FormControlLabel } from '../../FormControlLabel';
import { Typography } from '../../Typography';
import { VisualAssetImage } from '../../VisualAssetImage';

type CheckboxOptionProps = {
  checked: boolean;
  value: string;
  image?: VisualAsset;
  onAnswerClick: (value: string, checked: boolean) => void;
  children?: ReactNode;
  disabled?: boolean;
};

export const CheckboxOption = ({
  checked,
  value,
  onAnswerClick,
  children,
  image,
  disabled,
  ...otherProps
}: CheckboxOptionProps) => {
  const onChange = (event: SyntheticEvent<Element, Event>, selected: boolean) => {
    onAnswerClick((event.target as HTMLInputElement).value, selected);
  };

  const Control = (
    <>
      {image && <VisualAssetImage image={image} width={24} height={24} />}
      <Typography variant="text-body-sm">{children}</Typography>
    </>
  );

  return (
    <FormControlLabel
      control={<Checkbox />}
      label={Control}
      labelPlacement="start"
      checked={checked}
      onChange={onChange}
      value={value}
      variant={CheckboxVariant.OPTION}
      disabled={disabled}
      {...otherProps}
    />
  );
};
